<div class="st_modal_container">
  <div class="st_modal_title" [ngClass]="{ st_modal_dark_font_color: isDark }">
    {{ 'GENERAL.CONFIRM_YOUR_INFORMATION' | translate }}
  </div>
  <div mat-dialog-content>
    <div class="st_modal_description" [ngClass]="{ st_modal_dark_font_color: isDark }">
      <div fxFlex fxLayout="column" fxLayoutAlign="start" fxLayoutGap="16px" class="my_8">
        <div fxLayout="row" fxLayoutGap="8px">
          <div fxFlex fxLayout="column" fxFlex.gt-sm="100%">
            <span>{{ 'GENERAL.NAME' | translate }}:</span>
            <span class="weight_700">{{ user.name || '-' }}</span>
          </div>
        </div>

        <div fxLayout="row wrap" fxLayoutGap="8px">
          <div fxFlex fxLayout="column">
            <span>{{ 'GENERAL.USERNAME' | translate }}:</span>
            <span class="weight_700">{{ user.username || '-' }}</span>
          </div>
          <div fxFlex fxLayout="column">
            <span>{{ 'CREATE_ACCOUNT.EMAIL' | translate }}:</span>
            <span class="weight_700">{{ user.email || '-' }}</span>
          </div>
          <div fxFlex fxLayout="column">
            <span>{{ 'CREATE_ACCOUNT.SEX' | translate }}:</span>
            <span class="weight_700">{{ user.gender ? ('CREATE_ACCOUNT.' + user.gender | translate) : '-' }}</span>
          </div>
        </div>

        <div fxLayout="row wrap" fxLayoutGap="8px">
          <div fxFlex fxLayout="column">
            <span>{{ 'GENERAL.CONTACT' | translate }}:</span>
            <span class="weight_700">{{ parsePhone((user.contact_country_code || '') + user.contact) || '-' }}</span>
          </div>
          <div fxFlex fxLayout="column">
            <span>{{ 'CREATE_ACCOUNT.BIRTHDAY' | translate }}:</span>
            <span class="weight_700">{{ user.birth_date ? (user.birth_date | date : 'dd/MM/yyyy') : '-' }}</span>
          </div>
          <div fxFlex fxLayout="column">
            <span>{{ 'GENERAL.CPF' | translate }}:</span>
            <span class="weight_700">{{ cpfFormatter(user.cpf) || '-' }}</span>
          </div>
        </div>

        <label class="font_14 weight_700 my_8">{{ 'GENERAL.ADDRESS.ADDRESS' | translate }}</label>

        <div fxLayout="row wrap" fxLayoutGap="8px">
          <div fxFlex fxLayout="column">
            <span>{{ 'GENERAL.ADDRESS.STREET' | translate }}:</span>
            <span class="weight_700">{{ user.address?.street || '-' }}</span>
          </div>
          <div fxFlex fxLayout="column">
            <span>{{ 'GENERAL.ADDRESS.NUMBER' | translate }}:</span>
            <span class="weight_700">{{ user.address?.number || '-' }}</span>
          </div>
        </div>

        <div fxLayout="row wrap" fxLayoutGap="8px">
          <div fxFlex fxLayout="column">
            <span>{{ 'GENERAL.ADDRESS.NEIGHBORHOOD' | translate }}:</span>
            <span class="weight_700">{{ user.address?.neighborhood || '-' }}</span>
          </div>
          <div fxFlex fxLayout="column">
            <span>{{ 'GENERAL.ADDRESS.ZIPCODE' | translate }}:</span>
            <span class="weight_700">{{ user.address?.zipcode || '-' }}</span>
          </div>
          <div fxFlex fxLayout="column">
            <span>{{ 'GENERAL.ADDRESS.CITY' | translate }}:</span>
            <span class="weight_700">{{ user.address?.city || '-' }}</span>
          </div>
        </div>

        <div fxLayout="row wrap" fxLayoutGap="8px">
          <div fxFlex fxLayout="column">
            <span>{{ 'GENERAL.ADDRESS.COMPLEMENT' | translate }}:</span>
            <span class="weight_700">{{ user.address?.complement || '-' }}</span>
          </div>
          <div fxFlex fxLayout="column">
            <span>{{ 'GENERAL.ADDRESS.STATE' | translate }}:</span>
            <span class="weight_700">{{ user.address?.state || '-' }}</span>
          </div>
          <div fxFlex fxLayout="column">
            <span>{{ 'GENERAL.ADDRESS.COUNTRY' | translate }}:</span>
            <span class="weight_700">{{ user.address?.country || '-' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div mat-dialog-actions fxLayoutGap="10px">
    <st-button [stretch]="true" [boldText]="true" label="GENERAL.CONFIRM" (clicked)="close()" color="theme_color"></st-button>
  </div>
</div>
